import React, { useEffect, useRef, useState } from 'react';
import { Alert } from 'reactstrap';

export const FlashMessage = ({ type, message, id, deleteFlashMessage }) => {
    const statusBar = useRef(null);
    const [active, setActive] = useState(true);

    useEffect(() => {
        setTimeout(function () {
            setActive(false);
        }, 100);
    }, []);

    const transition = 'width ' + (5000 + 300) + 'ms';

    if (!message) return null;

    return (
        <Alert color={type} className="flex justify-between">
            {message}
            <span
                className={'alert-progress ' + (active ? 'active' : '')}
                ref={statusBar}
                style={{ transition: transition }}
            />

            <button onClick={() => deleteFlashMessage(id)}>×</button>
        </Alert>
    );
};
